import { render, staticRenderFns } from "./ExpandableItemIncapacidades.vue?vue&type=template&id=b638b878&scoped=true&"
import script from "./ExpandableItemIncapacidades.vue?vue&type=script&lang=js&"
export * from "./ExpandableItemIncapacidades.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableItemIncapacidades.vue?vue&type=style&index=0&id=b638b878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b638b878",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VTooltip})
